import { render, staticRenderFns } from "./ageCharts.vue?vue&type=template&id=d820822a&"
import script from "./ageCharts.vue?vue&type=script&lang=js&"
export * from "./ageCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports